import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../utils/env';
import { IPdfListResponse } from './supportPdf.types';

const pdfUrl = `${EnvWindow.REACT_APP_SUPPORT_PDF_API_URL}/Pdf`;

export async function getPdfList(): Promise<AxiosResponse<IPdfListResponse>> {
  return await axios.get(`${pdfUrl}`);
}

export async function viewPdf(id: string): Promise<AxiosResponse<File>> {
  return await axios.get(`${pdfUrl}`, { params: { id } });
}

export async function downloadPdf(id: string): Promise<AxiosResponse<File>> {
  return await axios({
    url: `${pdfUrl}/${id}`,
    method: 'GET',
    responseType: 'blob',
  });
}

const createFormdata = (title: string, file: File, id?: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('title', title);

  if (id) {
    formData.append('id', id);
  }

  return formData;
};

export async function createPdf(title: string, file: File): Promise<AxiosResponse> {
  const formData = createFormdata(title, file);

  return await axios.post(pdfUrl, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function updatePdf(newTitle: string, newFile: File, id: string): Promise<AxiosResponse> {
  const formData = createFormdata(newTitle, newFile, id);

  return await axios.put(pdfUrl, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function updateDownloadCount(pdfId: string): Promise<AxiosResponse<boolean>> {
  return await axios.put(`${pdfUrl}/${pdfId}`);
}

export const deletePdf = async (pdfId: string): Promise<AxiosResponse<boolean>> => {
  return await axios.delete(`${pdfUrl}/${pdfId}`);
};
